var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 26,
    viewBox: "0 0 76 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6186_4643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76 7.64053H71.0869V4.92783H66.1739V3H61.2343V11.9808V16.0282V17.5907H49V20.2889H61.2343V25H66.1739V23.0722H71.0869V20.3595H76V7.64053Z",
    fill: "#F6E709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 13.309H42.8623L34.6926 0L29.7856 18.5436L25.581 12.6607H14.2399V11.9784V3.11829H9.47741V5.02212H4.73871V7.70106H0V20.2617H4.73871V22.9407H9.47741V24.8445H14.2399V15.9754V15.3253H23.6204L31.2469 26L35.9655 8.16719L40.7591 15.9736H53V13.309Z",
    fill: "#F6E709"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6186_4643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/smallLogo.cd79622230d4b66018689299786548bb.svg";
export { ForwardRef as ReactComponent };